export default "__VITE_ASSET__hMFYoZSJ__"